import { Instagram, Mail } from "lucide-react";
import { WhatsAppIcon } from "@/components/icons";
import Logo, { LogoMark } from "@/components/Logo";
import { SITE } from "@/constants/site";
import { scrollToSection } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#050408]">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 px-5 py-12 md:flex-row md:items-start md:px-8">
        <div className="flex flex-col items-center gap-4 text-center md:items-start md:text-left">
          <Logo onClick={() => scrollToSection("accueil")} />
          <p className="max-w-xs text-sm leading-relaxed text-[#6c6685]">{SITE.tagline}. Chaque pièce est unique et signée.</p>
        </div>

        <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3" aria-label="Navigation pied de page">
          {[
            { id: "galerie", label: "Galerie" },
            { id: "tarifs", label: "Tarifs" },
            { id: "temoignages", label: "Témoignages" },
            { id: "contact", label: "Contact" },
          ].map((l) => (
            <button
              key={l.id}
              type="button"
              data-testid={`footer-link-${l.id}`}
              onClick={() => scrollToSection(l.id)}
              className="text-sm text-[#a09bb5] transition-colors hover:text-white"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="https://instagram.com/pokebastos06"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            data-testid="footer-social-instagram"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-[#a09bb5] transition-all duration-300 hover:border-fuchsia-400/50 hover:text-white"
          >
            <Instagram size={16} />
          </a>
          <a
            href="https://wa.me/33646251495"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            data-testid="footer-social-whatsapp"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-[#a09bb5] transition-all duration-300 hover:border-emerald-400/50 hover:text-white"
          >
            <WhatsAppIcon size={16} />
          </a>
          <a
            href="mailto:sebastiengrosso.13@gmail.com"
            aria-label="Email"
            data-testid="footer-social-email"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-[#a09bb5] transition-all duration-300 hover:border-cyan-400/50 hover:text-white"
          >
            <Mail size={16} />
          </a>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 sm:flex-row md:px-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#6c6685]">
            © {new Date().getFullYear()} {SITE.fullName} — Tous droits réservés
          </p>
          <a
            href="/confidentialite"
            data-testid="footer-privacy-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#6c6685] transition-colors hover:text-white"
          >
            Politique de confidentialité
          </a>
          <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#6c6685]">
            <LogoMark className="h-4 w-4" /> Créations made in France
          </p>
        </div>
      </div>
    </footer>
  );
}
